import { render } from "./PersonalSetting.vue?vue&type=template&id=3faec6dc&ts=true"
import script from "./PersonalSetting.vue?vue&type=script&lang=ts"
export * from "./PersonalSetting.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__